import React, { createContext, useContext } from "react";
import { Alert, Table, Layout } from "antd";

import ProductionDashboardStore from "./stores/productiondashboardstore";
import { Observer, observer } from "mobx-react-lite";
import { Responsive, WidthProvider } from "react-grid-layout";
import { ChartContainer } from "../../../shared/containers/ChartContainer";
import { DonutChart } from "./DonutChart";
import moment from "moment";
import { SubPageHeaderTitle } from "../../../shared/SubPageHeaderTitle";
import { ProductionBarChart } from "./ProductionBarChart";
const ResponsiveGridLayout = WidthProvider(Responsive);
const productionDashboardctx = createContext(ProductionDashboardStore);
const { Content } = Layout;
export const ProductionDashboardContainer = observer(() => {
  const productionDashboard = useContext(productionDashboardctx);

  const columns = [
    {
      title: "Asset",
      dataIndex: "asset",
      key: "name",
    },
    {
      title: "Lastest Production Refer Date",
      dataIndex: "productionDate",
      key: "productionDate",
      render: function (text, record, index) {
        return moment(text).format("dddd Do MMMM YYYY");
      },
    },
  ];
  return (
    <Layout
      style={{
        background: "#fff",
        padding: "10px",
        borderTop: "2px solid #008BF8",
      }}
    >
      <Content>
        {productionDashboard.loadError && (
          <Alert
            type="error"
            showIcon
            message="Production dashboard data is unavailable"
            description="The production service returned an error while loading dashboard data. Please contact the backend administrator."
            style={{ marginBottom: "10px" }}
          />
        )}
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            <ResponsiveGridLayout
              className="layout"
              draggableCancel=".chart-container-control, .chart-container-controls, .highcharts-container, .highcharts-contextmenu, .highcharts-menu"
              breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
              cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
              rowHeight={100}
            >
              <div
                key="1"
                data-grid={{ x: 0, y: 0, w: 4, h: 4 }}
                className=" ms-motion-fadeIn"
              >
                <SubPageHeaderTitle title="LATEST PRODUCTION FIGURES"></SubPageHeaderTitle>
                <ChartContainer>
                  <DonutChart
                    oilcol="oilLastUpdate"
                    gascol="gasLastUpdate"
                    nglcol="nglLastUpdate"
                    boecol="boeLastUpdate"
                  />
                  <ProductionBarChart
                    oilcol="oilLastUpdate"
                    gascol="gasLastUpdate"
                    nglcol="nglLastUpdate"
                    boecol="boeLastUpdate"
                  />
                </ChartContainer>
              </div>
              <div
                key="2"
                data-grid={{ x: 4, y: 0, w: 4, h: 4 }}
                className=" ms-motion-fadeIn"
              >
                <SubPageHeaderTitle title="MTD PRODUCTION FIGURES"></SubPageHeaderTitle>
                <ChartContainer>
                  <DonutChart
                    oilcol="oilMTDActual"
                    gascol="gasMTDActual"
                    nglcol="nglMTDActual"
                    boecol="boeMTDActual"
                  />
                  <ProductionBarChart
                    oilcol="oilMTDActual"
                    gascol="gasMTDActual"
                    nglcol="nglMTDActual"
                    boecol="boeMTDActual"
                  />
                </ChartContainer>
              </div>
              <div
                key="3"
                data-grid={{ x: 8, y: 0, w: 4, h: 4 }}
                className=" ms-motion-fadeIn"
              >
                <SubPageHeaderTitle title="YTD PRODUCTION FIGURES"></SubPageHeaderTitle>
                <ChartContainer>
                  <DonutChart
                    oilcol="oilYTDActual"
                    gascol="gasYTDActual"
                    nglcol="nglYTDActual"
                    boecol="boeYTDActual"
                  />
                  <ProductionBarChart
                    oilcol="oilYTDActual"
                    gascol="gasYTDActual"
                    nglcol="nglYTDActual"
                    boecol="boeYTDActual"
                  />
                </ChartContainer>
              </div>

              <div
                key="4"
                data-grid={{ x: 0, y: 1, w: 4, h: 3 }}
                className=" ms-motion-fadeIn"
              >
                <div className="ms-Grid-row" style={{ marginTop: "50px" }}>
                  <div className="ms-Grid-col ms-sm12">
                    <Observer>
                      {() => (
                        <Table
                          dataSource={[
                            ...productionDashboard.referDates.values(),
                          ]}
                          columns={columns}
                          pagination={false}
                          size="small"
                        />
                      )}
                    </Observer>
                  </div>
                </div>
              </div>
            </ResponsiveGridLayout>
          </div>
        </div>
      </Content>
    </Layout>
  );
});

